import React, { useState, useEffect } from "react";
import { BrowserRouter, Route } from "react-router-dom";
import Navigation from "./components/UI/Navigation/Navigation";
import MenuButton from "./components/UI/MenuButton/MenuButton";
import Home from "./pages/Home/Home";
import OurIdentity from "./pages/Identity/OurIdentity";
import AcademicEndeavors from "./pages/AcademicEndeavors/AcademicEndeavors";
import AlumniSuccess from "./pages/AlumniSuccess/AlumniSuccess";
import Community from "./pages/Community/Community";
import GlobalOpportunities from "./pages/GlobalOpportunities/GlobalOpportunities";
import SustainableLeadership from "./pages/SustainableLeadership/SustainableLeadership";
import StudentLife from "./pages/StudentLife/StudentLife";
import Footer from "./components/UI/Footer/Footer";
import ReactGA from "react-ga";
import "./App.css";

function App() {

  useEffect(() => {
    ReactGA.initialize('UA-9335397-12');
    ReactGA.pageview(window.location.pathname);
  }, []);

  const [menu, setMenu] = useState({ open: false });

  const toggleMenu = () => {
    let currentMenu = !menu.open;
    setMenu({ open: currentMenu });
  };

  return (
    <BrowserRouter>
      {menu.open ? <Navigation clicked={toggleMenu} /> : null}
      <MenuButton clicked={toggleMenu} menuOpen={menu} />

      <Route path="/identity" component={OurIdentity} />
      <Route path="/academic-endeavors" component={AcademicEndeavors} />
      <Route path="/alumni-success" component={AlumniSuccess} />
      <Route path="/community" component={Community} />
      <Route path="/global-opportunities" component={GlobalOpportunities} />
      <Route path="/sustainable-leadership" component={SustainableLeadership} />
      <Route path="/student-life" component={StudentLife} />
      <Route path="/" exact component={Home} />
      <Footer />
    </BrowserRouter>
  );
}

export default App;
